import { render, staticRenderFns } from "./charityDonations.vue?vue&type=template&id=d3ab0770&"
import script from "./charityDonations.vue?vue&type=script&lang=js&"
export * from "./charityDonations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports